module.exports = __webpack_public_path__ + "static/img/activity33.1cda57be.png";